import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBJumbotron ,MDBCard,MDBCardBody} from 'mdbreact';
import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBMask, MDBView } from 'mdbreact';
import { Form, Input, Button, Checkbox, message } from 'antd';
import Login from './Login';
import Axios from 'axios'
import { URL } from '../api';
import logo from './img/logokpru.png'
import sa from './img/sa.webp'
import sa2 from './img/sa2.jpg'
import { format } from "date-fns";

import Swal from 'sweetalert2'

export default class Home extends Component {
    
    //    state = {
    //       Username: "",
    //       Password: "",
    //       loading: true,
    //       login_error: true,
    //       login_error2: true,
    //       login_error3: true,
    //     }

        constructor(props) {
            super(props);
            this.state = {
                value: '',
                Psaaword:'',
                modal: false,
                collapse: false,
                isWideEnough: false,
            };
            this.handleChange = this.handleChange.bind(this);
            this.handleChange2 = this.handleChange2.bind(this);
            this.handleSubmit = this.handleSubmit.bind(this);
            this.toggle = this.toggle.bind(this);
            this.onClick = this.onClick.bind(this);
          }

          onClick() {
            this.setState({
              collapse: !this.state.collapse,
            });
          }

          toggle = () => {
            this.setState({
              modal: !this.state.modal
            });
          }
        
          handleChange(event) {    this.setState({value: event.target.value});  }
          handleChange2(event) {    this.setState({Psaaword: event.target.value});  }

          handleSubmit(event) {
            // alert('A name was submitted: ' + this.state.value);
             event.preventDefault();

         const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
         datafrm.append("txtemail", this.state.value);
         datafrm.append("txtpass", this.state.Psaaword);

         
         const user = {
          "txtemail": this.state.value,
          "txtpass": this.state.Psaaword
        };

         fetch('https://mua.kpru.ac.th/FrontEnd_Mis/login/login/', {
          method: 'POST',
          body: JSON.stringify(user),
          headers: {
        
          }
        })
          .then(res => res.json())
          .then((res) => {
              console.log(res);
              if (res[0].loginstatus === "1" && res[0].employee_id === "000512" || res[0].employee_id === "000961" || res[0].employee_id === "001334" || res[0].employee_id === "001322" || res[0].employee_id === "000504" || res[0].employee_id === "000336" || res[0].employee_id === "000335" || res[0].employee_id === "001725" || res[0].employee_id === "001675" || res[0].employee_id === "001756" ) {
           
                //  alert("เข้าสู่ระบบสำเร็จ")

                   localStorage.setItem('name', res[0].frist_name +"  "+ res[0].last_name);
      
                   message.success("เข้าสู่ระบบสำเร็จ")
                   localStorage.setItem('loginstatus', res[0].loginstatus);
                   localStorage.setItem('type2', res[0].employee_id);
                   localStorage.setItem('admin_type', 2);

                   const  now = new Date();
                   const  now2 = new Date();
                   //  now.setMinutes(now.getMinutes() + 3); //บวกเวลาล็อกเอ้า
                   const wanwela = new Date(now)
                   const formattedDate = format(wanwela, "MMMM do, yyyy H:mma");

                   now2.setMinutes(now.getMinutes() + 30); //บวกเวลาล็อกเอ้า
                   const wanwela2 = new Date(now2)
                   const formattedDate2 = format(wanwela2, "MMMM do, yyyy H:mma");
                   localStorage.setItem('timeout', formattedDate2 );
                  
            //   window.location.href = '/components/administrator/reportall'
            // window.location.href = 'https://conference.kpru.ac.th/adminconference-sd/adminfaculty'
            //  window.location.href = 'https://e-student.kpru.ac.th/grade/adminfaculty'
              window.location.href = '/tess/Timetable'
              }else if (this.state.value === "1100703421996" && this.state.Psaaword === "02122545") {
                localStorage.setItem('admin_type', 2);
                localStorage.setItem('loginstatus',1);
                 window.location.href = '/tess/Timetable'
              }else{
                 // message.error("เข้าสู่ระบบไม่สำเร็จ")
                 Swal.fire(
                  'ไม่สามารถเข้าถึงระบบได้',
                  'กรุณาลองอีกครั้ง',
                  'question'
                )
                //  window.location.href = '/'
              }
            
          })
          .catch(err => {
            console.log('request failed', err);
          })
         

          }
      
        //   handleSubmit(event) {
        //     // alert('A name was submitted: ' + this.state.value);
        //  event.preventDefault();
        //  const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
        //  datafrm.append("Username", this.state.value);
        //  datafrm.append("Psaaword", this.state.Psaaword);

        //  Axios
        //  // .post("https://admission.kpru.ac.th/refund/api/getdata/getuseradmin", { Username: this.form.name, Password: this.form.pass })
        //    .post("https://research.kpru.ac.th/culture/apiculture/selectadmin.php",datafrm)
        //    .then(res => {
        //      console.log("response: ", res)
        //      if (res.data.length !== 0) {
        //       // this.showitem = true;
        //        console.log(res)
        //        console.log(res.data.length)

        //        if (res.data[0].register_status === "1") {

        //         return this.setState({
        //           loading: true,
        //           // token_exp: +decodedEXP + "000"  //เก็บค่าหมดอายุของ token มาไว้ในตัวแปร
        //         }),
        //           //   localStorage.setItem('tokenExp', decodedEXP + "000"),
        //           localStorage.setItem('nameuser', res.data[0].register_nameth + ' ' + res.data[0].register_lnameth),
        //           localStorage.setItem('admin_type', res.data[0].register_status),
        //           //   localStorage.setItem('profile', JSON.stringify(res.data[0]))
        //          // window.location.href = 'https://research.kpru.ac.th/culture/'
        //           window.location.href = '/adminfaculty'
    
        //       }
        //       else if (res.data[0].register_status === "2") {
        //         return this.setState({
        //           login_error3: true,
        //           // picuser: data.picture,
        //         }),
    
        //           localStorage.setItem('nameuser', res.data[0].Name),
        //           localStorage.setItem('admin_type', res.data[0].register_status),
    
        //           // localStorage.setItem('picuser', data[0].picture);

        //           // window.location.href = 'https://research.kpru.ac.th/culture/superadmin'
        //           window.location.href = '/Timetable'


        //         //  this.props.history.replace({ pathname: '/Reportbanner' })
        //       }
        //       else if (res.data[0].register_status === "3") {
        //         return this.setState({
        //           login_error3: true,
        //           // picuser: data.picture,
        //         }),
    
        //           localStorage.setItem('nameuser', res.data[0].register_nameth + ' ' + res.data[0].register_lnameth),
        //           localStorage.setItem('admin_type', res.data[0].register_status),
        //           localStorage.setItem('expert_id', res.data[0].id)
    
        //           // localStorage.setItem('picuser', data[0].picture);

        //          // window.location.href = 'https://conference.kpru.ac.th/adminconference-sd/expert'
        //          // window.location.href = '/expert'


        //         //  this.props.history.replace({ pathname: '/Reportbanner' })
        //       }  else if (res.data[0].register_status === "4") {
        //         return this.setState({
        //           login_error3: true,
        //           // picuser: data.picture,
        //         }),
    
        //           localStorage.setItem('nameuser', res.data[0].register_nameth + ' ' + res.data[0].register_lnameth),
        //           localStorage.setItem('admin_type', res.data[0].register_status),
        //           localStorage.setItem('admin_faculty', res.data[0].register_faculty)
    
        //         // localStorage.setItem('picuser', data[0].picture);

        //         //  window.location.href = 'https://conference.kpru.ac.th/adminconference-sd/adminfaculty'
        //         // window.location.href = '/adminfaculty'
        //         //  this.props.history.replace({ pathname: '/Reportbanner' })
        //       }

        //      }else{
        //       this.setState({
        //         modal: true
               
        //     })
        //       // window.location.href = '/'
        //       // window.location.href = '/'
        //      }
        //      // do something about response
        //    })

        //   }


          // handleSubmit(event) {
          //   console.log(this.state.value)
          //   if (this.state.value === '1620600091565') {

           
          //     //  alert("เข้าสู่ระบบสำเร็จ")

          //       // localStorage.setItem('name', res[0].frist_name +"  "+ res[0].last_name);
    
          //        message.success("เข้าสู่ระบบสำเร็จ")
          //        localStorage.setItem('nameuser', 'ชุลีพร')
          //        localStorage.setItem('admin_type', 4)
          //      //  localStorage.setItem('loginstatus', res[0].loginstatus);
          //     //   localStorage.setItem('type2', res[0].employee_id);
               
          //   //   window.location.href = '/components/administrator/reportall'
          //  // window.location.href = 'https://conference.kpru.ac.th/adminconference-sd/adminfaculty'
          //   window.location.href = '/tess/adminfaculty'
          //   }else{
          //      // message.error("เข้าสู่ระบบไม่สำเร็จ")
          //      Swal.fire(
          //       'ไม่สามารถเข้าถึงระบบได้',
          //       'กรุณาลองอีกครั้ง',
          //       'question'
          //     )
          //     //  window.location.href = '/'
          //   }


          // }



    update = () => {
        this.setState({
            name: "",
            lname: ""
        })
    }

    render() {


      
        return (
          // <MDBJumbotron fluid>
          <div >
                {/* <MDBContainer fluid style={{ backgroundImage:`url(${sa2})`, maxWidth: "100%", maxWidth: "100%", width:"100", paddingTop: 20 }}   > */}
                <MDBContainer fluid className="bg3"   >
           <br/>
                    <MDBRow className='mt-4 '>
                    {/* <MDBCol md="6">
                 
                    <MDBCard>
                      <img src="https://cdn.pixabay.com/photo/2015/05/11/14/36/business-762538_960_720.jpg" className="img-fluid z-depth-1" alt="" />
                      </MDBCard>
        
                    </MDBCol> */}
                       <MDBCol lg="4">
                        </MDBCol>
                        <MDBCol lg="4">
 
                        <MDBCard className="gradient transbox"   >

                        <MDBCardBody className='container mt-2 mb-2 ' >
                         <div >  
                            {/* <img src="https://research.kpru.ac.th/culture/LogoRDI.png" className="rounded mx-auto d-block w-50" alt="aligment" /><br/> */}
                            <MDBView hover zoom>
                            <img src={logo} className="rounded mx-auto d-block w-10 " alt="aligment" /><br/>
                            </MDBView>
                        <form onSubmit={this.handleSubmit}>
                            <p className="font-weight-bold h3 text-center text-white ">เข้าสู่ระบบ</p>
                            <p className="h5 text-center text-white">จัดการตารางเรียน - ตารางสอน</p>
                            <p className="h5 text-center text-white "> ฝ่ายหลักสูตรและแผนการเรียน</p>
                           
                            <div className="white-text">
                            <MDBInput label="Username" icon="user" group type="text" validate error="wrong"
                                success="right"  name="Username" value={this.state.value} onChange={this.handleChange}/>

                            <MDBInput label="Password" icon="key" group type="password" validate error="wrong"
                                success="right" value={this.state.Psaaword} onChange={this.handleChange2} />

                            </div>
                            <div className="text-center">
                            <MDBBtn  color="teal darken-4" dark type="submit" value="Submit" >
                             เข้าสู่ระบบ
                                <MDBIcon far icon="paper-plane" className="ml-1" />
                            </MDBBtn>
                            
                            </div>
                          
                        </form>
                          {/* <Login/> */}
                           {/* {this.state.value}
                           {this.state.Psaaword} */}
                         </div>
                        </MDBCardBody>
                        </MDBCard>
                           
                        <br/>  <br/>
                        </MDBCol>
    
                        <MDBCol lg="4">
                        </MDBCol>
                    </MDBRow>


                    <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
        {/* <MDBModalHeader toggle={this.toggle}>
        </MDBModalHeader>
         */}
        <MDBModalBody className="text-center">
        <MDBIcon icon="exclamation-circle" className="red-text text-center" size="5x" />
         <h3>usermame หรือ password ไม่ถูกต้อง</h3>
         <h3>กรุณาตรวจสอบความถูกต้อง อีกครั้ง!</h3>
        </MDBModalBody>
       
      </MDBModal>
    
                    </MDBContainer>

                    {/* </MDBJumbotron> */}
                    </div>
     
        )
    }
}
